/**
 * Utility functions for creating external links
 */

/**
 * Creates a Google Maps URL for a given location
 * @param {string} location - The location name or address
 * @param {string} destination - Optional destination context (like city, country)
 * @returns {string} - Google Maps URL for the location
 */
export const createMapLink = (location, destination = '') => {
  if (!location) return '';
  
  let searchQuery = location;
  
  // If we have a destination, add it to make the search more specific
  if (destination && !location.toLowerCase().includes(destination.toLowerCase())) {
    searchQuery = `${location}, ${destination}`;
  }
  
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(searchQuery)}`;
};

/**
 * Determines if a string resembles a location that can be mapped
 * @param {string} text - String to check
 * @returns {boolean} - Whether the string looks like a location
 */
export const isLocationString = (text) => {
  if (!text || typeof text !== 'string') return false;
  
  // Common location indicators in text
  const locationIndicators = [
    'street', 'avenue', 'ave', 'boulevard', 'blvd', 'plaza', 'square',
    'park', 'museum', 'gallery', 'restaurant', 'café', 'cafe', 'hotel',
    'landmark', 'tower', 'bridge', 'cathedral', 'temple', 'palace',
    'gardens', 'castle', 'market'
  ];
  
  const lowercaseText = text.toLowerCase();
  
  // Check if any location indicators are present
  return locationIndicators.some(indicator => lowercaseText.includes(indicator));
}; 